import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {PushDevicesState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: PushDevicesState = {
    pushDevices: [],
    pushMappsVersions: [],
    pushSdkVersions: [],
    pushOsVersions: [],
};


export const pushDevice: Module<PushDevicesState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
